import { gql } from "@apollo/client";

//To create classroom
export const CREATE_CLASSROOM = gql`  
mutation createClassroomBySchoolAdmin($input: createClassroomByAdminInput!) {
  createClassroomBySchoolAdmin(input: $input) {
    message
  }
}
`;

//To Reset the class code 
export const RESET_CLASS_CODE = gql`
mutation updateClassroomCode($input: editClasscodeInput!) {
  editClasscode(input: $input) {
    message
  }
}`;

//To delete the classroom
export const DELETE_CLASSROOM = gql`
mutation deleteClassroom($input:deleteClassroomInput!) {
  deleteClassroomById(input: $input) {
    message
  }
}`;

//To get the classroom details by id
export const GET_CLASSROOM_BY_ID=gql`
query getClassroomById($cId: UUID!) {
  classroomByCId(cId: $cId) {
    cId
    cCode
    cName
    cOriginalName
    cStudentsCount
    classroomSubjectsByCId(condition: {deletedAt: null}) {
      nodes {
        csAvatarUrl
        subjectBySjId {
          sjName
          sjOriginalName
        }
      }
    }
    saId
    teacherClassroomsByCId(condition: {isHeadTeacher: true}) {
      nodes {
        tId
        teacherByTId {
          tName
        }
      }
    }
  }
}`;

//To edit the classroom
export const EDIT_CLASSROOM = gql`
mutation updateClassroom($input: editClassroomInput!) {
  editClassroom(input: $input) {
    message
  }
}`;